import { render } from "./EditorialA.vue?vue&type=template&id=08c9d392&scoped=true"
import script from "./EditorialA.vue?vue&type=script&lang=js"
export * from "./EditorialA.vue?vue&type=script&lang=js"

import "./EditorialA.vue?vue&type=style&index=0&id=08c9d392&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08c9d392"]])

export default __exports__